import { Link } from 'react-router-dom';
import { getHotVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const hotVideos = getHotVideos().slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              精选优质内容，发现更多精彩视频
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hotVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200 transition-colors duration-300 cursor-pointer"
              >
                <div className="relative w-full h-48 md:h-56 overflow-hidden">
                  <img
                    src={video.coverImage}
                    alt={video.title}
                    title={`${video.title} - 蘑菇视频`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md">
                    {video.duration}
                  </div>
                  {video.isHot && (
                    <div className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
                      热门
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {video.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
                    {video.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-full bg-background-300 overflow-hidden">
                        <img src={video.authorAvatar} alt={video.author} className="w-full h-full object-cover" />
                      </div>
                      <span className="text-xs text-foreground-500">{video.author}</span>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {video.views > 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-heart-line"></i>
                        {video.likes > 10000 ? `${(video.likes / 10000).toFixed(1)}万` : video.likes}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/category/gaoxiao"
              className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 rounded-full text-sm font-medium text-foreground-700 hover:bg-background-100 hover:border-background-400 transition-all duration-200 whitespace-nowrap"
            >
              查看更多内容
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}